module.exports = __webpack_public_path__ + "img/ic_feedback_shared.ad5c3a3e.png";